import { useLocation } from "react-router";
import { Location } from "react-router";

interface LocationWithState extends Location {
    state: { productId: string };
}

export const useAppLocation = (): LocationWithState => useLocation() as LocationWithState;
